import React, { useEffect, useState, useRef, forwardRef, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { initiateSearch, formatDate_MM_DD_YYYY } from '../../../../../../../../Assests/Utility';
import { AppConstant } from '../../../../../../../../Assests/AppConstant'
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import DrilldownTable from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import WarehouseSearch from '../../../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearch';
import { usePrevious } from '../../../../../../../Common/CustomHooks/usePrevious';
import moment from 'moment-timezone';
import { getPoSSselector } from '../../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import CustomDropDown from '../../../../../../../Common/CustomDropDown/CustomDropDown';
import './FacilityRatingsTabular.css'
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../../../../Components/DatePicker/DatePicker.css"
import { CustomPaginationSS } from '../../../../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { getRemoteConfigSelector } from '../../../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import CustomTimeSelector from '../../../../../../../Common/CustomTimeSelector/CustomTimeSelector';
import "react-datepicker/dist/react-datepicker.css";
import DatePickerSS from '../../../../../../../DatePickerSS/DatePickerSS';

const FacilityRatingsTabular = (props) => {
    const { themeSelected = 'light-mode', startDate, setStartDate, endDate, setEndDate, view, isError, setCurrentFilterDetails, startTimeState, setStartTimeState, endTimeState, setEndTimeState } = props;
    const dispatch = useDispatch();
    const [facilityRatingsList, setFacilityRatingsList] = useState([]);
    const pOSS = useSelector(getPoSSselector);
    const { facilityRatingsReportList, facilityRatingsAllData, arrangeOrder, arrangeKey } = pOSS;
    const userObj = useSelector(getUserSelector);
    const [searchStr, setSearchStr] = useState('');
    const { selectedWarehouse, cu_id, userType } = userObj;
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const divRef = useRef(null);
    const [showLoading, setShowLoading] = useState(true);
    const previousTable = usePrevious(currentTable);
    // moment.tz.setDefault(selectedWarehouse?.TimeZone);
    const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'All' });
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    //Get Config from store
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const [showStartDate, setShowStartDate] = useState(false);
    const [showEndDate, setShowEndDate] = useState(false);
    const [maxEndDate, setMaxEndDate] = useState(new Date());


    useEffect(() => {
        if (isDateTimeValid()) {
            dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
            setFacilityRatingsList([]);
            setCurrentFilterDetails(currentFilterSelected);
            setTimeout(() => {
                fetchFacilityRatings();
            }, 50);
        }
    }, [currentFilterSelected]);


    const apptsTitleDD = [
        // { id: 'serial_num', name: 'S.No' },
        { id: 'first_name', name: 'First Name' },
        { id: 'last_name', name: 'Last Name' },
        { id: 'facility_rating', name: 'Ratings' },
        { id: 'timeStamp', name: 'Rated on' }
    ]

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    })

    useEffect(() => {
        // setStartDate(null);
        // setEndDate(null);
        // setStartTimeState(null);
        // setEndTimeState(null);

        dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
        setShowLoading(true);
        setFacilityRatingsList([]);
        return () => {
            dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
            setFacilityRatingsList([]);
        }
    }, [])

    const isDateTimeValid = () => {
        return (
            moment(startDate).isValid() &&
            moment(endDate).isValid() &&
            typeof startTimeState === 'string' && startTimeState.trim() !== '' &&
            typeof endTimeState === 'string' && endTimeState.trim() !== '' &&
            !isError
        );
    };



    useEffect(() => {
        if (!isError && startDate && endDate && startTimeState && endTimeState) {

            dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });

            // fetchFacilityRatings()
            setTimeout(() => {
                if (isDateTimeValid()) {
                    fetchFacilityRatings();
                }
            }, 50);
        }
    }, [startDate, endDate, startTimeState, endTimeState, isError])

    // useEffect(() => {
    //     fetchFacilityRatings()
    // }, [currentFilterSelected, currentPage])

    useEffect(() => {
        if (facilityRatingsReportList && facilityRatingsReportList.length) {
            setFacilityRatingsList(facilityRatingsReportList)
            if (searchStr && searchStr.length > 3) {
                const searchedArr = initiateSearch(facilityRatingsReportList, searchStr, 'GroupName');
                setFacilityRatingsList(searchedArr);
            }
        } else {
            setFacilityRatingsList([])
        }
    }, [facilityRatingsReportList])

    useEffect(() => {

        if (_.upperCase(facilityRatingsAllData?.status) === 'SUCCESS') {
            setShowLoading(false);
            // setFacilityRatingsList(facilityRatingsReportList)
            if (facilityRatingsAllData?.data?.currentPage) {
                setCurrentPage(facilityRatingsAllData?.data?.currentPage || 1)
                setTotalPages(facilityRatingsAllData?.data?.totalPages || 1)
            }
        } else {
            setShowLoading(false)
            setCurrentPage(facilityRatingsAllData?.data?.currentPage || 1)
            setTotalPages(facilityRatingsAllData?.data?.totalPages || 1)
        }

    }, [facilityRatingsAllData])

    /**
     * Function to call facility rationg api
     * @param {*} pageNo 
     * @param {*} limit 
     */
    const fetchFacilityRatings = (pageNo = 1, limit = PaginationDefaultLimit) => {
        setFacilityRatingsList([]);
        if (userType === 'USER') {
            // const start = dateRangeObj?.start ? moment(dateRangeObj.start).utc() : null;
            // const end = dateRangeObj?.end ? moment(dateRangeObj.end).utc() : null;
            setShowLoading(true);
            // const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
            const params = {
                "warehouse_id": selectedWarehouse.ID,
                // "startDate": moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                // "endDate": moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "startDate": combineDateAndTime(startDate, startTimeState, true),
                "endDate": combineDateAndTime(endDate, endTimeState, true),
                "currentPage": pageNo,
                "itemsPerPage": limit,
                "rating": currentFilterSelected?.name === 'All' ? null : currentFilterSelected?.name,
                "type": view
            }
            dispatch({ type: sagaActions.UPDATE_FACILITY_RATINGS, payload: params });
        } else if (userType === 'SUPERADMIN') {
            // console.log("🚀 SUPERADMIN: See what will happen in this case")
        } else {
            // console.log(userType, " 🚀: This report is not accessible")
        }
    }

    const combineDateAndTime = (date, time, addTimeZone) => {
        if (!date || !time) return null;

        // Extract date and time parts separately
        const datePart = moment(date).format('YYYY-MM-DD');

        // Convert to UTC and format
        if (addTimeZone) {
            return `${datePart}T${time}:00Z`;
        }
        return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
    };


    useEffect(() => {
        if (searchStr.length > 3 && facilityRatingsReportList.length) {
            const searchedArr = initiateSearch(facilityRatingsReportList, searchStr, 'GroupName');
            setFacilityRatingsList(searchedArr);
        } else if (searchStr === '') {
            setFacilityRatingsList(facilityRatingsReportList)
        }
    }, [searchStr])

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: el.load_id,
                // 0: index + 1,
                0: el.first_name,
                1: el.last_name,
                2: el.facility_rating,
                3: moment(el.timeStamp) || '-',
            }
        })
    }


    const getBodyData = () => {
        if (facilityRatingsList && facilityRatingsList.length) {
            return formatListDataDrillDown(facilityRatingsList)
        }
        else {
            return []
        }
    }

    const showCustomDropDownForFilters = () => {
        const filterDataArr = [
            {
                name: 'All',
            },
            {
                name: 'Great',
            },
            {
                name: 'Good',
            },
            {
                name: 'Okay',
            }
        ]
        return (
            <div className='d-flex align-items-center'>
                <div className='me-2 titleFiltersLeaveMeta'>{AppConstant.commonStrings.select} </div>
                <CustomDropDown themeSelected={themeSelected} data={filterDataArr} placeHolder={currentFilterSelected.name} onSelect={(event) => setCurrentFilterSelected(event)} keyStr={'name'} />
            </div>
        )
    }

    /**
     * Function to call fetch facilty ration fn on page change
     * @param {*} pageNo 
     * @param {*} limit 
     */
    const pageChange = (pageNo, limit) => {
        dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
        setFacilityRatingsList([]);
        setTimeout(() => {
            if (isDateTimeValid()) {
                fetchFacilityRatings(pageNo, limit)
            }
        }, 50);
    }


    const handleTimeChange = (value, name) => {
        if (name === 'startTime') {
            setStartTimeState(value);
        } else if (name === 'endTime') {
            setEndTimeState(value);
        }
    };

    const handleTimeError = (fieldName) => {
        // Placeholder for handling field-level validation if needed
        if (!fieldName) return;
    };
    /**
* Function to handle startdate change
* @param {*} date
*/
    const handleStartDate = (date) => {
        let shouldClearEndDate = false;

        // Case 1: startDate > endDate
        if (endDate && date > endDate) {
            shouldClearEndDate = true;
        }

        // Case 2: difference between start and end > 3 months
        if (endDate && !shouldClearEndDate) {
            const diffInMonths = moment(endDate).diff(moment(date), 'months', true); // fractional months
            if (diffInMonths > 3) {
                shouldClearEndDate = true;
            }
        }

        if (shouldClearEndDate) {
            setEndDate(null);
        }

        setStartDate(date);
        getMaxEndDate(date);
    };

    /**
     * Function to return max end date
     */
    const getMaxEndDate = (startDate) => {
        let currentDate = new Date();
        let threeMonthslater = new Date(startDate);
        threeMonthslater.setMonth(startDate.getMonth() + 3);
        threeMonthslater.setDate(threeMonthslater.getDate() - 1);
        if (currentDate <= threeMonthslater) {
            setMaxEndDate(currentDate);
        } else {
            setMaxEndDate(threeMonthslater);
        }
    };


    return (
        <div className=''>
            <div className='d-flex justify-content-between my-2 mx-3'>
                <div className='fw-bold'>{'Facility Ratings'}</div>
                <div className='d-flex justify-content-end align-items-end gap-3'>

                    <div className="d-flex appt-report-header gap-3 align-items-center" style={{ marginBottom: '2px' }}>
                        <div className="pos-rel">
                            <div className="d-flex flex-column align-items-start">
                                <label className="boldText m-2 f-14">
                                    <i className="fa-regular fa-calendar"></i> Start Date{" "}
                                </label>
                                <button
                                    className={"datePickerBtn h-100 w-100"}
                                    onClick={() => setShowStartDate(!showStartDate)}
                                    disabled={false}
                                >
                                    <span className="btn-title">
                                        {startDate
                                            ? formatDate_MM_DD_YYYY(startDate)
                                            : "Start Date"}
                                    </span>
                                    <i
                                        className="fa-regular fa-calendar"
                                        style={{ marginInline: "9px" }}
                                    ></i>
                                </button>
                                {showStartDate && (
                                    <div className="appt-summary-ss-datePicker csce-ss-datePicker">
                                        <DatePickerSS
                                            maxDate={new Date()}
                                            setSelectedDate={handleStartDate}
                                            selectedDate={startDate}
                                            closeCalendar={() => {
                                                setShowStartDate(!showStartDate);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="pos-rel">
                            <div className="d-flex flex-column align-items-start">
                                <label className="boldText m-2 f-14">
                                    <i className="fa-regular fa-calendar"></i> End Date{" "}
                                </label>

                                <button
                                    className={"datePickerBtn h-100 w-100"}
                                    onClick={() => setShowEndDate(!showEndDate)}
                                    disabled={false}
                                >
                                    <span className="btn-title">
                                        {endDate
                                            ? formatDate_MM_DD_YYYY(endDate)
                                            : "End Date"}
                                    </span>
                                    <i
                                        className="fa-regular fa-calendar"
                                        style={{ marginInline: "9px" }}
                                    ></i>
                                </button>
                                {showEndDate && (
                                    <div className="appt-summary-ss-datePicker">
                                        <DatePickerSS
                                            setSelectedDate={setEndDate}
                                            minDate={new Date(startDate)}
                                            maxDate={maxEndDate}
                                            selectedDate={endDate}
                                            closeCalendar={() => {
                                                setShowEndDate(!showEndDate);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column align-items-start" style={{ width: '200px' }}>
                        <label className="boldText m-0 f-14">
                            <i className="fa-regular fa-clock"></i> Start Time{" "}
                        </label>
                        <CustomTimeSelector
                            name="startTime"
                            title="Start Time"
                            value={startTimeState}
                            onChange={handleTimeChange}
                            handleErrors={handleTimeError}
                        />
                    </div>



                    <div className='d-flex flex-column align-items-start' style={{ width: '200px' }}>
                        <label className="boldText m-0 f-14">
                            <i className="fa-regular fa-clock"></i> End Time{" "}
                        </label>
                        <CustomTimeSelector
                            name="endTime"
                            title="End Time"
                            value={endTimeState}
                            onChange={handleTimeChange}
                            handleErrors={handleTimeError}
                        />
                    </div>


                    <div className='ms-2'>
                        {
                            showCustomDropDownForFilters()
                        }
                    </div>
                    <div className='ms-2 w-30'>
                        <WarehouseSearch
                            placeholder={AppConstant.poManagement.searchPOSection.searchTitleStr}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>
                    <div className='d-flex align-items-center mx-3'>
                        {/* <DownloadSection singlePageDownload={true} root={''} subRoot={''} name={'Facility Ratings'} themeSelected={themeSelected} currentTable={currentTable} currentTableRef={currentTableRef} /> */}
                    </div>
                </div>

            </div>
            <div className='facilityRatingsListContainer' ref={divRef}>
                <DrilldownTable
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={apptsTitleDD}
                    showCollapse={false}
                    showInput={false}
                    showSort={true}
                    hasCollapsableContent={false}
                    collapsableData={[]}
                    accordionPrimaryIndex={1}
                    arrangeOrder={arrangeOrder}
                    arrangeKey={arrangeKey}
                    drillDownReport={facilityRatingsList}
                    initiateDrillDownReport={showLoading}
                    loaderArray={4}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'facilityRatingsObj' }}
                    showUTCTime={true}
                />
            </div>
            {/* {facilityRatingsList && facilityRatingsList.length ? <PaginationIMS wrapperPositionClass="mx-1 d-flex justify-content-center" currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} isLoading={ showLoading} /> : ''} */}
            {
                !_.isEmpty(facilityRatingsAllData) && facilityRatingsAllData?.data?.Items?.length ?
                    <div className='f-14 detention-status-pagination'>
                        <CustomPaginationSS
                            pageNo={facilityRatingsAllData.data.currentPage}
                            pageSize={facilityRatingsAllData.data.itemsPerPage}
                            first={(Number(facilityRatingsAllData.data.currentPage) === 1) ? true : false}
                            last={Math.ceil(facilityRatingsAllData.data.totalCount / Number(facilityRatingsAllData.data.itemsPerPage)) === (Number(facilityRatingsAllData.data.currentPage)) ? true : false}
                            totalElements={facilityRatingsAllData.data.totalCount}
                            totalPages={facilityRatingsAllData.data.totalPages}
                            pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
                        />
                    </div> : ""
            }
        </div >
    )
}

export default FacilityRatingsTabular